export default {
  login: "auth/login",
  logout: "auth/logout",
  company: "company",
};
